import { COLORS } from "../constants/constants";
import { setUsername } from "../store/slices/authSlice";
import { onLogout, setRefreshTokenMetadata } from "../store/slices/commonSlice";
import { setApplicantType, setClientApplicantId, setClientApplicationId, setClientId, setKsaCorporate, setRejectionMsg } from "../store/slices/constantSlice";
import { resetInvestmentSlice } from "../store/slices/investmentsSlice";
import { resetNotificationSlice } from "../store/slices/notificationSlice";
import { clearFcmToken } from "./notification_service";
import store from "../store/store";
import dynamicfunction from "./dynamicfunction";
import { getItem, setItem } from "./storage_services";
import { getContentKeyAccToLang, refreshAccessToken, setToken, setUser, showToast } from "./utils";

export const number_regix = /^\d*\.?\d{0,2}$/;
export const unit_regix = /^\d*\.?\d{0,4}$/;
export const integer_regex = /^\d+$/;
export const urlReg =
  /^(http[s]?:\/\/(www\.)?|ftp:\/\/(www\.)?|www\.){1}([0-9A-Za-z-\.@:%_\+~#=]+)+((\.[a-zA-Z]{2,3})+)(\/(.)*)?(\?(.)*)?/g;

export const lettersOnly = /^[A-Za-z\s]+$/;
export const digitsOnly = /^[0-9]+$/;
export const alphaNumeric = /^[A-Za-z0-9]+$/;
export const decimalNumber = /^\d{1,15}(\.\d{1,2})?$/;
export const digitsAndHyphenRegex = /^[0-9-]+$/;

export const emailReg = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
export const numberReg = /^\+|0{1,}(?:[0-9] ?){6,14}[0-9]$/;
export const phoneRegex = /^\+?(\d\s?){10,18}$/;
export const numericRegix = /^[0-9]+$/;
export const numericDashRegix = /^[0-9-]+$/;
export const numericWithDecimalRegix = /^\d*\.?\d+$/;
export const alphabetRegix = /^[A-Za-z\u0600-\u06FF ]+$/;
export const alphaNumericRegix = /^[A-Za-z\d\u0600-\u06FF]+(?: [A-Za-z\d\u0600-\u06FF]+)*$/;
export const alphaNumericSpecialCharacterRegix =
  /^(?! )[A-Za-z\d\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF @.,_\-!#\/]+(?<! )$/;
export const arabicNumericSpecialCharacterRegix =
  /^(?! )(?=.*[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF])[\d\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF @.,_\-!#\/]+(?<! )$/

export function requestHandler({
  apiService,
  setData,
  setLoading,
  isSuccessMessage = false,
  param_data,
  onDone,
  onError,
  isErrorMessage = true,
  isLogin = false,
}) {
  return async (dispatch) => {
    try {
      setLoading && dispatch(setLoading(true));
      const response = await apiService(param_data);
      if (
        response?.status === true ||
        response?.data?.status ||
        response?.status === 200 ||
        response?.status === 201 ||
        response?.status === 204 ||
        response === true
      ) {
        setData && dispatch(setData(response?.result));
        isSuccessMessage &&
          showToast({
            icon: "success",
            title: response?.message ?? "",
          });
        onDone && onDone(response);
      } else {
        showToast({
          icon: "error",
          title: response?.message ?? "Something went wrong",
        });
      }
    } catch (error) {
      onError && onError(error);
      isErrorMessage && (error?.status !== 401 || (error?.status === 401 && error?.data?.isClosed)) &&
        showToast({
          icon: "error",
          title:
            error?.data?.message ??
            error?.data?.Message ??
            "Something went wrong",
        });

      if (error?.status === 401 && !isLogin) {
        const tempUsername = getItem("username");
        dispatch(onLogout());
        setToken('');
        dispatch(setUsername(tempUsername ?? null));
        dispatch(setRefreshTokenMetadata(null));
        dispatch(resetInvestmentSlice());
        dispatch(resetNotificationSlice());
        clearFcmToken();
        dispatch(setApplicantType(null));
        dispatch(setKsaCorporate(null));
        dispatch(setClientApplicationId(null));
        dispatch(setClientApplicantId(null));
        dispatch(setClientId(null));
        dispatch(setRejectionMsg(null));
        setItem("username", tempUsername);
        window.location.href = "/#/funds/available-funds";
      }
    } finally {
      setLoading && dispatch(setLoading(false));
    }
  };
}

export function downloadBase64File({ base64Data, fileName, type }) {
  const linkSource = type
    ? `data:${type};base64,${base64Data}`
    : `data:application/pdf;base64,${base64Data}`;
  const downloadLink = document.createElement("a");
  downloadLink.href = linkSource;
  downloadLink.download = fileName;

  document.body.appendChild(downloadLink);
  downloadLink.click();
  document.body.removeChild(downloadLink);
}

export async function downloadFileFromUrl({ url, fileName }) {
  try {
    const response = await fetch(url);
    const blob = await response.blob();

    const blobUrl = window.URL.createObjectURL(blob);
    const downloadLink = document.createElement("a");
    downloadLink.href = blobUrl;
    downloadLink.download = fileName || "download";

    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);

    window.URL.revokeObjectURL(blobUrl); // cleanup
  } catch (error) { }
}

export const formatGIIN = (value) => {
  if (!value) return '';

  let raw = value.replace(/\D/g, '');
  let formatted = '';

  if (raw.length > 0) formatted = raw.substring(0, 6);
  if (raw.length > 6) formatted += '-' + raw.substring(6, 11);
  if (raw.length > 11) formatted += '-' + raw.substring(11, 13);
  if (raw.length > 13) formatted += '-' + raw.substring(13, 16);

  return formatted;
};

export const iconColor = (svg, color) => {
  svg?.querySelectorAll('*').forEach((el) => {
    el?.setAttribute('stroke', color ?? COLORS.primary);
  });
};

export const passwordRules = (password) => ({
  lowercase: /[a-z]/.test(password),
  uppercase: /[A-Z]/.test(password),
  numeric: /[0-9]/.test(password),
  minLength: password.length >= 6,
});

export const clientSuspendedToast = (isArabic) => {
  const dashboardContent = store.getState()?.content?.dashboardContent ?? null
  const getContentKey = (key) => {
    return getContentKeyAccToLang(dashboardContent, key, isArabic);
  };

  showToast({
    icon: "error",
    title: getContentKey('suspended_message'),
  });
}